import React from "react";
import "./TouchBalloon.scss";

interface IProps {

}

export function TouchBalloon(props: IProps) {
    return (
        <div className="touch-balloon-wrapper">
            Touch us!
        </div>
    )
}
